import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap'; // Type defintitions

import * as TYPES from '../../types'; // Constants

import * as CONSTANTS from '../../constants'; // JSS

import { Image, Link, RichText } from '@sitecore-jss/sitecore-jss-react'; //ga tracker

import gaTracker from '../../util/ga-analytics/gaTracker'; // Design System

import Heading from '../heading/Heading';
import VideoImage from '../videoimage/VideoImage';
import Wrapper from '../wrapper/Wrapper';

var MegaBanner = function MegaBanner(props) {
  var _model$title3, _model$subtitle, _model$videoUrl, _model$videoUrl$value, _model$link1$value, _model$link2$value;

  var model = props.model,
      type = props.type,
      align = props.align,
      layout = props.layout,
      _props$isEditing = props.isEditing,
      isEditing = _props$isEditing === void 0 ? false : _props$isEditing,
      htmlId = props.htmlId,
      position = props.position;
  var classType = 'cb-banner';
  classType += typeof type !== 'undefined' && type !== 'default' ? " cb-banner--side cb-banner--".concat(type) : '';
  classType += typeof align !== 'undefined' ? " cb-banner--side-".concat(align) : '';
  var container = typeof type !== 'undefined' ? "cb-banner__container" : '';

  var bannerClick = function bannerClick() {
    var _model$value, _model$value$title, _model$title, _model$value2, _model$value2$title, _model$title2;

    var data = {
      gtm: {
        uniqueEventId: '47',
        elementTarget: (model === null || model === void 0 ? void 0 : (_model$value = model.value) === null || _model$value === void 0 ? void 0 : (_model$value$title = _model$value.title) === null || _model$value$title === void 0 ? void 0 : _model$value$title.value) || (model === null || model === void 0 ? void 0 : (_model$title = model.title) === null || _model$title === void 0 ? void 0 : _model$title.value) || (model === null || model === void 0 ? void 0 : model.value),
        elementText: (model === null || model === void 0 ? void 0 : (_model$value2 = model.value) === null || _model$value2 === void 0 ? void 0 : (_model$value2$title = _model$value2.title) === null || _model$value2$title === void 0 ? void 0 : _model$value2$title.value) || (model === null || model === void 0 ? void 0 : (_model$title2 = model.title) === null || _model$title2 === void 0 ? void 0 : _model$title2.value) || (model === null || model === void 0 ? void 0 : model.value),
        elementId: htmlId
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  var gtmData = {
    "data-gaattrbannertitle": model === null || model === void 0 ? void 0 : (_model$title3 = model.title) === null || _model$title3 === void 0 ? void 0 : _model$title3.value,
    "data-gaattrbannersubtitle": model === null || model === void 0 ? void 0 : (_model$subtitle = model.subtitle) === null || _model$subtitle === void 0 ? void 0 : _model$subtitle.value,
    "data-gaattrbannerposition": htmlId
  };
  return /*#__PURE__*/React.createElement(Wrapper, {
    layout: layout,
    className: classType
  }, /*#__PURE__*/React.createElement("div", {
    className: container,
    id: htmlId,
    onClick: bannerClick
  }, ((model === null || model === void 0 ? void 0 : model.image) || (model === null || model === void 0 ? void 0 : model.videoUrl)) && /*#__PURE__*/React.createElement(ImageVideoContainer, {
    image: model === null || model === void 0 ? void 0 : model.image,
    video: model === null || model === void 0 ? void 0 : model.videoUrl,
    autoplay: model.autoplay,
    displayControls: model.displayControls,
    playsound: model.playsound,
    isEditing: isEditing
  }), (model === null || model === void 0 ? void 0 : model.bannerStickerImage) && (model === null || model === void 0 ? void 0 : (_model$videoUrl = model.videoUrl) === null || _model$videoUrl === void 0 ? void 0 : (_model$videoUrl$value = _model$videoUrl.value) === null || _model$videoUrl$value === void 0 ? void 0 : _model$videoUrl$value.href) === '' && /*#__PURE__*/React.createElement(BannerStickerContainer, {
    bannerStickerImage: model === null || model === void 0 ? void 0 : model.bannerStickerImage
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-banner__copy-container"
  }, (model === null || model === void 0 ? void 0 : model.subtitle) && /*#__PURE__*/React.createElement(BannerCopyComponent, {
    field: model.subtitle,
    gtmData: gtmData,
    level: "2",
    className: "cb-banner__subtitle"
  }), (model === null || model === void 0 ? void 0 : model.title) && /*#__PURE__*/React.createElement(BannerCopyComponent, {
    field: model.title,
    level: "2",
    className: "cb-banner__title"
  }), typeof (model === null || model === void 0 ? void 0 : model.text) !== "undefined" && /*#__PURE__*/React.createElement(BannerCopyRichText, {
    text: model.text
  }), typeof (model === null || model === void 0 ? void 0 : model.link1) !== "undefined" || (model === null || model === void 0 ? void 0 : model.link2) !== "undefined" ? /*#__PURE__*/React.createElement("div", {
    className: "cb-banner__cta"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
    className: "row-grid"
  }, Boolean((_model$link1$value = model.link1.value) === null || _model$link1$value === void 0 ? void 0 : _model$link1$value.href) ? /*#__PURE__*/React.createElement(CtaItem, {
    link: model.link1,
    id: "".concat(htmlId, "-1"),
    gtmData: gtmData,
    type: "primary"
  }) : "", Boolean((_model$link2$value = model.link2.value) === null || _model$link2$value === void 0 ? void 0 : _model$link2$value.href) ? /*#__PURE__*/React.createElement(CtaItem, {
    link: model.link2,
    id: "".concat(htmlId, "-2"),
    gtmData: gtmData,
    type: "secondary"
  }) : ""))) : "")));
};

var ImageVideoContainer = function ImageVideoContainer(_ref) {
  var _video$value;

  var image = _ref.image,
      video = _ref.video,
      autoplay = _ref.autoplay,
      displayControls = _ref.displayControls,
      playsound = _ref.playsound,
      isEditing = _ref.isEditing;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-banner__image-container ".concat((video === null || video === void 0 ? void 0 : (_video$value = video.value) === null || _video$value === void 0 ? void 0 : _video$value.href) && "cb-banner__video-container")
  }, /*#__PURE__*/React.createElement(VideoImage, {
    image: image,
    video: video,
    autoplay: autoplay,
    displayControls: displayControls,
    playsound: playsound,
    isEditing: isEditing
  }));
};

var BannerStickerContainer = function BannerStickerContainer(_ref2) {
  var bannerStickerImage = _ref2.bannerStickerImage;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-banner__image-bg"
  }, /*#__PURE__*/React.createElement(Image, {
    media: bannerStickerImage
  }));
};

var BannerCopyComponent = function BannerCopyComponent(_ref3) {
  var field = _ref3.field,
      level = _ref3.level,
      className = _ref3.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-banner__copy"
  }, /*#__PURE__*/React.createElement(Heading, {
    field: field,
    level: level,
    className: className
  }));
};

var BannerCopyRichText = function BannerCopyRichText(_ref4) {
  var text = _ref4.text;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-banner__copy cb-l-margin-medium--bottom"
  }, /*#__PURE__*/React.createElement(RichText, {
    field: text,
    tag: "p",
    className: "cb-banner__text"
  }));
};

var CtaItem = function CtaItem(props, type) {
  var _props$link = props.link,
      link = _props$link === void 0 ? {} : _props$link,
      id = props.id,
      _props$gtmData = props.gtmData,
      gtmData = _props$gtmData === void 0 ? {} : _props$gtmData; // console.log(id, gtmData, "VALUES")

  var buttonClass = type === 'secondary' ? CONSTANTS.BANNER_SECONDARY_BUTTON : CONSTANTS.BANNER_PRIMARY_BUTTON;

  var ctaClick = function ctaClick(e) {
    var _link$value, _link$value2;

    var data = {
      gtm: {
        uniqueEventId: '48',
        elementText: (_link$value = link.value) === null || _link$value === void 0 ? void 0 : _link$value.text,
        elementLink: (_link$value2 = link.value) === null || _link$value2 === void 0 ? void 0 : _link$value2.href,
        elementId: id
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  return /*#__PURE__*/React.createElement(Col, {
    className: "cb-banner__cta-item"
  }, /*#__PURE__*/React.createElement(Link, _extends({
    field: link,
    showLinkTextWithChildrenPresent: "true",
    onClick: ctaClick,
    id: id
  }, gtmData, {
    className: typeof link.value.class !== "undefined" && link.value.class !== "" ? link.value.class : buttonClass
  })));
};

export default MegaBanner;